import { UserType, CustomerType } from '@/models/enums';
import { User } from '@/models/www/store/User';
import { UserState } from '@/models/www/store/UserState';
import { storageService } from '@/services/storage.service';
import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => {
        return {
            user: {
                type: UserType.Unknown,
                customerType: CustomerType.Default,
            } as User
        } as UserState
    },
    getters: {
        getUser(): User {
            return this.user;
        },
        getIsLoggedIn(): boolean {
            return this.user.type !== UserType.Unknown && !!storageService.getToken();
        },
        getIsTravelCardMember(): boolean {
            return this.user.customerType === CustomerType.Travelclub;
        },
        getIsShareholder(): boolean {
            return this.user.customerType === CustomerType.Shareholder;
        },
        getUserType(): UserType {
            return this.user.type;
        }
    },
    actions: {
        setUser(user: User) {
            this.user = user;
        },
    },
    persist: {
        enabled: true,
        strategies: [
            { storage: localStorage, paths: ['user'], expiration: 1500000 },
        ],
    },
})